/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyInPayTrailInitOutput
 */
export interface MoneyInPayTrailInitOutput {
    /**
     * Transaction ID. You will this this value to confirm the transaction
     * @type {number}
     * @memberof MoneyInPayTrailInitOutput
     */
    id?: number;
    /**
     * Redirected URL for the client on the iDeal page payment
     * @type {string}
     * @memberof MoneyInPayTrailInitOutput
     */
    actionUrl?: string;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInPayTrailInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInPayTrailInitOutput interface.
 */
export function instanceOfMoneyInPayTrailInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInPayTrailInitOutputFromJSON(json: any): MoneyInPayTrailInitOutput {
    return MoneyInPayTrailInitOutputFromJSONTyped(json, false);
}

export function MoneyInPayTrailInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInPayTrailInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'actionUrl': !exists(json, 'actionUrl') ? undefined : json['actionUrl'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInPayTrailInitOutputToJSON(value?: MoneyInPayTrailInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'actionUrl': value.actionUrl,
        'error': value.error,
    };
}

